
import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import wx from 'weixin-js-sdk';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'

import Datetime from 'vux/src/components/datetime/index.vue'


export default {
components: {
cmBlank,cmLoadmore,Popup,Group,PopupHeader,XButton,Radio,Datetime, wx
},
directives: {
TransferDom
},
data () {
return {
blankShow:false,
loadStatus:false,
loadmoreText:'正在加载。。。',
busy:false,
code:'',
pageFlag:2,
hasNext:0,
lastId:0,
list:[],
isActive:0,
statusArr:[
{
key:0,
num:0,
value:'全部',
},
{
key:6,
num:0,
value:'已出厂待发货',
},
{
key:7,
num:0,
value:'已发货待揽收',
},
],
}
},
created(){

this.config();


},
amount(){
this.code = '';
},
methods:{
copy(val){
this.$func.copy(val,event);
},
search(){
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
},
resetSearch(){
this.code = '';
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
},
searchSubmit(){
this.lastId = 0;
this.pageFlag = 2;
this.list = [];
this.loadmore();
},
selectStatus(val){
this.isActive = val;
this.search();
},
getWaybillOrderCount(){
this.$api.getWaybillOrderCount({code:this.code}).then((res)=>{
if(res){
this.statusArr.forEach((item)=>{
item.num = res.data[item.key] || 0;;
})
console.log(this.statusArr);
}
})
},
queryExpress(code){
this.$router.push({name:'queryExpress',params:{code:code}})
},
getList(){
this.$api.getWaybillOrderList({last_id:this.lastId,page_flag:this.pageFlag,code:this.code}).then((res)=>{
if(res){
if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
},
barOrder(code){
this.$router.push({name:'barOrder',params:{code:code}})
},
sendWaybillOrder(id){
this.$func.confirm('确定要物流下单送衣？','提示',()=>{
this.$api.sendWaybillOrder({id:id}).then((res)=>{
if(res){
this.$func.showToast('物流下单成功');
setTimeout(()=>{
this.search();
this.getWaybillOrderCount();
}, 300);
}
});
})
},
scanQRCode(){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['barCode'],
success: function (res) {
setTimeout(()=>{

that.code = res.resultStr.split(',')[1];
let prefix = that.code.substring(0,4);
if(prefix == 'JDVG'){
that.code = that.code.substring(0,15);
}
that.search();
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
loadmore(){
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';
this.getList();
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},1500)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/waybillOrder.vue